module.exports = __webpack_public_path__ + "img/applestore.8e1e7d3f.png";